import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/antd.css';
import EventEmitter from 'eventemitter3';
import { IPOGlobalStyle, IPOTipPop, LangEnum } from '@hylaa-npm/ipod';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import enUS from 'antd/lib/locale/en_US';
import Index from './container/index';
import './locale';
import store, { persistor } from './redux/store';
import { Globalstyle } from './styles/globalStyle';
import { getStorage } from './utils/storage';
import { PersistGate } from 'redux-persist/integration/react';

window.eventEmitter = new EventEmitter();

ReactDOM.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<ConfigProvider
				locale={getStorage('lang') && getStorage('lang') === LangEnum.EN ? enUS : zhCN}>
				<BrowserRouter>
					<IPOTipPop />
					<Index />
					<IPOGlobalStyle />
					<Globalstyle />
				</BrowserRouter>
			</ConfigProvider>
		</PersistGate>
	</Provider>,
	document.getElementById('root'),
);
